var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":{ name: 'PathContent', params: { id: _vm.id }}}},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.description||'\n'))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }